// @flow
import JQueryView, { on } from '../../../../common/JQueryView';
import statusNone from '../../../../../../../assets/images/views/company/director_meetings/status_none.png';
import statusLocal from '../../../../../../../assets/images/views/company/director_meetings/status_local.png';
import statusOnline from '../../../../../../../assets/images/views/company/director_meetings/status_online.png';

declare var $: any;

export default class JoinMemberView extends JQueryView {
  constructor() {
    super('.simple_form');
    this.render();
  }

  @on({ event: 'change', selector: $('input[type=checkbox]') })
  onChangeOfficerApprovalUserCompany() {
    const director_count = $('.director input:checkbox:checked').length;
    const auditor_count = $('.auditor input:checkbox:checked').length;
    $('.director-count').text(director_count);
    $('.auditor-count').text(auditor_count);
    const selectedCount = $(
      'input:checkbox:checked[id^="officer_approval_director_meeting_officer_approval_user_companies_joinable_attributes_"]',
    ).length;
    const totalCount = $(
      'input:checkbox[id^="officer_approval_director_meeting_officer_approval_user_companies_joinable_attributes_"]',
    ).length;

    if (totalCount === selectedCount) {
      $('input#all_checked').prop('checked', true);
    } else {
      $('input#all_checked').prop('checked', false);
    }
  }

  changeJoinStatus = (target: any): void => {
    let icon = statusNone;
    if (target.val() == 'local') icon = statusLocal;
    if (target.val() == 'online') icon = statusOnline;

    target.css(
      'background-image',
      `url(${icon}), url('data:image/svg+xml;charset=utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="48" d="M112 184l144 144 144-144"/></svg>')`,
    );
  };

  @on({ event: 'change', selector: '.select-image' })
  onChangeJoinSelect(event: any) {
    this.changeJoinStatus($(event.target));
  }

  @on({ event: 'change', selector: '#all_checked' })
  onChangeAllCheck() {
    const allChecked = $('#all_checked').prop('checked');
    if (allChecked) {
      $('.join-checkbox').prop('checked', true);
    } else {
      $('.custom-control-input').each((_i, v) => {
        if (!$(v).hasClass('disabled')) $(v).prop('checked', false);
      });
    }
  }

  @on({
    event: 'click',
    selector: '#all-online-field label',
  })
  onClickAllOnline() {
    $('#all-local').prop('checked', false);
  }

  @on({
    event: 'click',
    selector: '#all-local-field label',
  })
  onClickAllLocal() {
    $('#all-online').prop('checked', false);
  }

  @on({
    event: 'click',
    selector: '#all-apply',
  })
  onClickAllApply(event: any) {
    event.preventDefault();
    let status = 'none';

    if ($('#all-online').prop('checked')) {
      status = 'online';
    } else if ($('#all-local').prop('checked')) {
      status = 'local';
    }
    if (status == 'none') return;

    $('.join-mode-select').each((_i, v) => {
      const target = $(v);
      target.val(status);
      this.changeJoinStatus(target);
    });
  }

  @on({
    event: 'click',
    selector: '#all-select-join-mode-dropdown div',
  })
  onClickAllDropdown() {
    $('#all-select-join-mode-dropdown')
      .find('div')
      .addClass('show');
    $('#all-select-join-mode-dropdown').addClass('show');
  }

  render() {
    $('.select-image').each((_i, v) => {
      this.changeJoinStatus($(v));
    });

    this.onChangeOfficerApprovalUserCompany();
  }
}
